// extracted by css-extract-rspack-plugin
export default {"projectName":"_75d0f711"};